"use strict";
window.theme = window.theme || {}
theme.ComponentsPageFaqTwoColumnGrid = function() {
    function ComponentsPageFaqTwoColumnGrid() {
        this.container = {
            listtoggle: document.querySelectorAll('.page-faq-two-column-grid > .grid-container > .grid-column > .content-item')
        };
        this.button = {
            viewall: document.querySelectorAll('.page-faq-two-column-grid > button'),
            expandable: document.querySelectorAll('.page-faq-two-column-grid > .grid-container > .grid-column > .content-item > p.h2'),
            newsletter: document.querySelectorAll('.page-faq-two-column-grid > .grid-container > .grid-column > .content-item a[href="#newsletter"]'),
            newsletterPopup: document.querySelector('button.Newsletter')
        };
        this.cart = {
        }
        this.load();               

    }
    ComponentsPageFaqTwoColumnGrid.prototype.load = function() {
        var _ = this;
        if(_.button.viewall) {
                _.button.viewall.forEach(button => {
                    button.addEventListener('click', function() {
                        this.parentElement.querySelectorAll('.content-item').forEach(list => {
                            if(!list.classList.contains('for-less-item')) {
                                list.classList.toggle('active');
                            }
                        })
                        this.closest('button').classList.toggle('expanded');
                    })
                })
        }
        if(_.button.expandable.length > 0) {
            _.button.expandable.forEach(btn => {
                btn.addEventListener('click', (event) => {
                    event.target.closest('p.h2').nextElementSibling.classList.toggle('active');
                    event.target.closest('p.h2').querySelector('i').classList.toggle('open');
                    const nextEl = event.target.closest('p.h2').querySelector('i').nextElementSibling;
                    if(nextEl) {
                        dataLayer.push({
                            'event': 'FAQS_question_expanded',
                            'Question': nextEl.innerText
                        });                    
                    }
                })
            })

            if(_.button.newsletter) {
                _.button.newsletter.forEach(btn => {
                    btn.addEventListener('click', (e) => {
                        e.preventDefault();
                        _.button.newsletterPopup.click();
                    })
                })
            }
        }
    }

    theme.ComponentsPageFaqTwoColumnGrid = new ComponentsPageFaqTwoColumnGrid;
}

theme.ComponentsPageFaqTwoColumnGrid();
